import React, { useState } from 'react';
import ValutaFilter from '@eika-infrastruktur/ui-valuta-filter';
import Card from '../card';
import InfoButton from '../info-button';
import SpareGraf from '../spare-graf';
import spareUtregning from '../../utils/spareutregning';
import StepInput from '../step-input';
import ResultatBoks from '../resultat-boks';
import { useConfig } from './default-config';
import replaceVariableInString from '../../utils/config-util';

const Sparekalkulator = () => {
    const { texts, numbers, links } = useConfig();
    const [antallAar, setAntallAar] = useState(numbers.antallAarDefault);
    const [sparingPerMnd, setSparingPerMnd] = useState(numbers.sparingPerMndDefault);
    const fondSum = spareUtregning(antallAar, sparingPerMnd, numbers.fondsRenteProsent, numbers.inflasjonProsent, 0);
    const bankSum = spareUtregning(antallAar, sparingPerMnd, numbers.bankRenteProsent, numbers.inflasjonProsent, 0);
    const innsattSum = spareUtregning(antallAar, sparingPerMnd, 0, 0, 0);
    const anbefalingText = antallAar < numbers.fondVsBankAarLimit ? texts.bankAnbefalingText : texts.fondAnbefalingText;
    const formattedAnbefalingText = replaceVariableInString(anbefalingText, 'antallAar', antallAar);
    const formattedGrafHeader = replaceVariableInString(texts.grafHeader, 'antallAar', antallAar);
    const formattedInfoModalText = `${texts.infoModalText1}
        ${replaceVariableInString(texts.infoModalText2, 'fondsRenteProsent', numbers.fondsRenteProsent)}
        ${replaceVariableInString(texts.infoModalText3, 'bankRenteProsent', numbers.bankRenteProsent)}
        ${texts.infoModalText4} \n
        ${texts.infoModalText5} \n
        ${texts.infoModalText6}`;
    const aarSuffix = antallAar < 2 ? texts.aarSuffix : texts.aarPluralSuffix;
    return (
        <Card header={texts.cardHeader}>
            <form className="row">
                <div className="col-xs-12 col-md-6">
                    <StepInput
                        maxValue={999999}
                        onChange={(value: number) => setSparingPerMnd(value)}
                        minValue={0}
                        stepSize={100}
                        suffix="kr"
                        label={texts.sparePerMndText}
                        value={sparingPerMnd}
                        incrementValueText={texts.incrementValueText}
                        decrementValueText={texts.decrementValueText}
                        valueFormatter={(value: number) => ValutaFilter(value, ' ', 0)}
                    />
                </div>
                <div className="col-xs-12 col-md-6">
                    <StepInput
                        onChange={(value: number) => setAntallAar(value)}
                        label={texts.antallAarText}
                        maxValue={99}
                        minValue={0}
                        stepSize={1}
                        suffix={aarSuffix}
                        value={antallAar}
                        incrementValueText={texts.incrementValueText}
                        decrementValueText={texts.decrementValueText}
                    />
                </div>
            </form>
            <h4 className="h4">{formattedAnbefalingText}</h4>
            <ResultatBoks
                header={antallAar < numbers.fondVsBankAarLimit ? texts.bankLabel : texts.fondLabel}
                colorSwitch={!(antallAar < numbers.fondVsBankAarLimit)}
                forventetBelopText={texts.forventetTotalBelop}
                forventetBelop={antallAar < numbers.fondVsBankAarLimit ? bankSum : fondSum}
                totaltInnskuddText={texts.dittInnskudd}
                totaltInnskudd={innsattSum}
            />
            <h4 className="h4">{formattedGrafHeader}</h4>
            <SpareGraf
                sparingPerMnd={sparingPerMnd}
                oppspart={0}
                fondsRenteProsent={numbers.fondsRenteProsent}
                bankRenteProsent={numbers.bankRenteProsent}
                inflasjonProsent={numbers.inflasjonProsent}
                antallAar={antallAar}
                fondLabel={texts.fondLabel}
                bankLabel={texts.bankLabel}
                millionForkortelse={texts.millionForkortelse}
                milliardForkortelse={texts.milliardForkortelse}
            />
            <InfoButton label={texts.infoModalLabel} header={texts.infoModalHeader} info={formattedInfoModalText} />
            {links.redirectURL && links.redirectURL.url && (
                <>
                    <p className="sub-header">
                        {antallAar < numbers.fondVsBankAarLimit ? texts.smartsparTextBank : texts.smartsparTextFond}
                    </p>
                    <a className="btn btn-primary" href={links.redirectURL.url}>
                        {texts.buttonText}
                    </a>
                </>
            )}
        </Card>
    );
};

export default Sparekalkulator;
